var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsLimitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.625 27.875L42.1184 16.1875H42.0625V27.875L51.625 27.875ZM37.8125 16.1875H15.5V42.75H51.625V32.125H37.8125V16.1875Z",
    fill: "#111213"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_4803_12217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 54H54L49.9128 47H17.0872L13 54Z",
    fill: "#111213"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 5C51.8324 7.3322 53.6678 9.16756 56 10C53.6678 10.8324 51.8324 12.6678 51 15C50.1676 12.6678 48.3322 10.8324 46 10C48.3322 9.16756 50.1676 7.3322 51 5Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0357 1C57.5411 2.41598 58.6555 3.53031 60.0714 4.03571C58.6555 4.54112 57.5411 5.65545 57.0357 7.07143C56.5303 5.65545 55.416 4.54112 54 4.03571C55.416 3.53031 56.5303 2.41598 57.0357 1Z",
    fill: "#1A1B1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4654 9.5C59.9708 10.916 61.0851 12.0303 62.5011 12.5357C61.0851 13.0411 59.9708 14.1555 59.4654 15.5714C58.96 14.1555 57.8457 13.0411 56.4297 12.5357C57.8457 12.0303 58.96 10.916 59.4654 9.5Z",
    fill: "#1A1B1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4803_12217",
    x: 7,
    y: 41,
    width: 53,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_4803_12217"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsLimitation);
export default __webpack_public_path__ + "static/media/reports-limitation.688d2b36fbfe1cd902657c87280a2458.svg";
export { ForwardRef as ReactComponent };